"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useAdvancedState_1 = __importDefault(require("../useAdvancedState"));
const useCurPageTitle = (title) => {
    const { listen, location } = (0, react_router_dom_1.useHistory)();
    const state = (0, useAdvancedState_1.default)({ title: document === null || document === void 0 ? void 0 : document.title, path: location === null || location === void 0 ? void 0 : location.pathname }, [title]);
    //? ------------------------------ useEffect ------------------------------------------------
    (0, react_1.useEffect)(() => {
        if (!title)
            return;
        document.title = title;
    }, [title]);
    (0, react_1.useEffect)(() => listen(({ pathname }) => {
        var _a, _b;
        if (pathname === ((_a = state === null || state === void 0 ? void 0 : state.org) === null || _a === void 0 ? void 0 : _a.path))
            return;
        document.title = (_b = state === null || state === void 0 ? void 0 : state.org) === null || _b === void 0 ? void 0 : _b.title;
    }), [title]);
};
exports.default = useCurPageTitle;
